<template>
    <li>
        <a :href="'/beispiel/' + getInstanceURI(this.getFirstInstance())"
           v-bind:class="[
               settings.subclass, settings.subclass + parentModel.category,
               item.position ? settings.subclass + item.position : '',
               {'c-tile-nav__tile-sub--active': isActive()},
               {'c-tile-nav__tile-sub--inactive': (activeMechanism && !isActive())}
           ]"
           @click.prevent="setActive" :data-active="(isModelActive()) ? '1' : '0'" :data-color="parentModel.color" :data-title="item.title" v-on="{ mouseenter: showTooltip, mouseleave: hideTooltip, mousemove: moveMouse }">
           <span class="c-tile-nav__link-text">{{item.title}}</span>
        </a>
        <ul class="c-tile-nav__wrapper-sub2">
            <li is="nav-task" v-for="(task, taskIndex) in item['tasks']" :item="getChild(task)" :index="taskIndex" :uid="task" :parentModel="parentModel" :parentMechanism="item"></li>
        </ul>
    </li>
</template>

<script>
    import mixins from "../mixins"

    export default {
        data () {
            return {

            }
        },
        created () {
            store.commit('extendTasks', this.item['tasks'])
        },
        mixins: [mixins],
        computed: {
            settings () {
                return store.state.settings
            },
            activeMechanism () {
                return store.state.runtime.activeItems['mechanism']
            }
        },
        methods: {
            setActive (event) {
                let uid = null
                if(!this.isActive()) uid = this.uid
                store.commit('unsetActiveItems')
                store.commit('setActiveInstance', this.getFirstInstance())
                this.pushInstanceRoute(this.getFirstInstance())
            },
            isActive () {
                return (this.uid === this.activeMechanism)
            },
            hasChilds () {
                return (this.item['tasks'].length > 0)
            },
            getChild (uid) {
                return (store.state.data['tasks'][uid])
            },
            getFirstInstance () {
                let taskId = this.item['tasks'][0]
                let task = this.$store.state.data['tasks'][taskId]
                return task['instances'][0]
            },
            isModelActive () {
                return parseInt(this.$store.state.runtime.activeItems['model']) === parseInt(this.parentModel.id)
            }
        },
        model: {
            prop: 'active',
            event: 'change'
        },
        props: {
            // this allows using the `value` prop for a different purpose
            item: {
                type: Object,
            },
            parentModel: {
                type: Object,
            },
            index: {
                type: Number
            },
            uid: {
                type: Number
            },
            // use `checked` as the prop which take the place of `value`
            active: {
                type: Boolean,
                default: false
            }
        }
    }
</script>


// WEBPACK FOOTER //
// NavMechanism.vue?fd19fdc0